import { render, staticRenderFns } from "./ProcessEdit.html?vue&type=template&id=faf21a78&external"
import script from "./ProcessEdit.ts?vue&type=script&lang=ts&external"
export * from "./ProcessEdit.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports